import http from "../../http";
import ApiConstants from '../../constants/ApiConstants';
import { ACTION, MODULE } from "./PermissionUtils";
import { getCapitalized } from "../../utility/Utility";

class UserPermissionService {
    static ROLE_DATA = null;

    static getModules(countryCode) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.GET_MODULES(countryCode)}`;
        return http.get(URL);
    }

    static getRoles() {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.GET_ROLES}`;
        return http.get(URL);
    }

    static saveRole(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.ADD_ROLE}`;
        return http.post(URL, payload);
    }

    static updateRole(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.UPDATE_ROLE}`;
        return http.patch(URL, payload);
    }

    static deleteRole(roleId) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.DELETE_ROLE}/${roleId}`;
        return http.delete(URL);
    }

    static getUserRole(userId) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.GET_USER_ROLE}/${userId}`;
        return http.get(URL);
    }

    static assignRole(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.ASSIGN_ROLE}`;
        return http.post(URL, payload);
    }

    static getUserRoles() {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.PERMISSION.GET_USER_ROLES}`;
        return http.get(URL);
    }

    static getActionName(action, module) {
        let actionName = `${getCapitalized(String(action).toLowerCase())} ${module.name}`;

        if (module.key === MODULE.REPORTS && action === ACTION.VIEW) {
            actionName = `${getCapitalized(String(ACTION.VIEW).toLowerCase())} / ${getCapitalized(String(ACTION.EXPORT).toLowerCase())} ${module.name}`;
        } else if(module.key === MODULE.EXPENSE_CLAIM && action === ACTION.EDIT){
            actionName = `${getCapitalized(String(ACTION.EDIT).toLowerCase())} ${getCapitalized(String(ACTION.DRAFT).toLowerCase())} ${module.name}`;
        } else if(module.key === MODULE.EXPENSE_CLAIM && action === ACTION.VIEW){
            actionName = `${getCapitalized(String(ACTION.VIEW).toLowerCase())} / ${getCapitalized(String(ACTION.EXPORT).toLowerCase())} ${module.name}`;
        } else if (module.key === MODULE.TEAM_REPORT) {
            if (action === ACTION.CREATE) {
                actionName = "Create Clock In/Out Entry";
            } else if (action === ACTION.EDIT) {
                actionName = "Edit Clock In/Out Entry";
            }
        }

        return actionName;
    }

    static getInvitedUsers() {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.INVITE.GET_INVITED_USER}`;
        return http.get(URL);
    }

    static inviteUser(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.INVITE.INVITE_USER}`;
        return http.post(URL, payload);
    }

    static cancelInvite(userId) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.INVITE.CANCEL_INVITE(userId)}`;
        return http.delete(URL);
    }
}

export default UserPermissionService;
